<template>
    <yandex-map 
      :coords="[53.2282985712013, 34.31553600000001]"
      zoom="8"
      :cluster-options="{
      1: {clusterDisableClickZoom: false,
      clusterBalloonContentBodyLayout: 'cluster#balloonAccordionContent'
      }
      }"
      :controls="controls"
      :placemarks="placemarks"  
      :behaviors="['drag', 'dblClickZoom', 'rightMouseButtonMagnifier', 'multiTouch']"
      map-type="map"
      :scroll-zoom="false"
      @map-was-initialized="initHandler"
      >
    </yandex-map>
</template>
<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import ObjectsData from './objects.js'
import ymapsTouchScroll from './ymaps-touch-scroll.js'
import isMobile from 'ismobilejs'
import Utils from '../Utils.js'
export default {
  name: 'myMap',
  data () {
    return {
    }
  },
  computed: {
    controls: function () {
      let desktop = ['typeSelector', 'zoomControl', 'fullscreenControl']
      let controls = desktop
      if (isMobile.phone) {
        desktop.pop()
        controls = desktop
      }
      return controls
    },
    placemarks: function () {
      return ObjectsData.map(function (item) {
        let nmb = '0' + item.id
        nmb = nmb.slice(-2)
        let imagePath = require('../assets/photo/objects/' + nmb + '-s.jpg')
        // let srcset = require(imagePath + nmb + '-s.jpg') + ''
        let balloonMinHeight = 320
        let balloonMinWidth = 320
        let height = Utils.getDocumentHeight()
        const width = Utils.getDocumentWidth()
        if (width >= 576) {
          imagePath = require('../assets/photo/objects/' + nmb + '-m.jpg')
          if (!isMobile.phone) {
            balloonMinWidth = 576
            balloonMinHeight = 426
          }
        }
        if (width >= 1400) {
          imagePath = require('../assets/photo/objects/' + nmb + '-l.jpg')
          if (!isMobile.phone) {
            balloonMinWidth = 992
            balloonMinHeight = 600
          }
        }
        let text = item.object + '<br/>Стоимость объекта - ' + item.finance + ', доля федерального бюджета - ' + item.federalBudget
        let generatePreset = function (branch) {
          let category = {
            'Благоустройство': 'islands#blueHydroCircleIcon',
            'Детские сады': 'islands#blueFamilyCircleIcon',
            'Дороги': 'islands#blueAutoCircleIcon',
            'Здравоохранение': 'islands#blueMedicalCircleIcon',
            'Инфраструктура': 'islands#blueFactoryCircleIcon',
            'Образование': 'islands#blueEducationCircleIcon',
            'Спорт': 'islands#blueSportCircleIcon'
          }
          return category[branch]
        }
        let generateBalloonContent = function (image, text, address) {
          return '<div class="balloon-table">' +
           ' <div class="balloon-table__body">' +
           ' <div class="balloon-table__row">' +
           ' <div class="balloon-table__cell ballon-table__image_default" style="background-image:url(' + image + ')">&nbsp;</div>' +
           ' </div>' +
           ' <div class="balloon-table__row">' +
           ' <div class="balloon-table__cell ballon-table__text_default">' + text + '</div>' +
           ' </div>' +
           ' <div class="balloon-table__row">' +
           ' <div class="balloon-table__cell ballon-table__address_default">' + address + '</div>' +
           ' </div>' +
           ' </div>' +
           ' </div>'
        }

        return {
          coords: [item.latitude, item.longitude],
          properties: {
/*            ballonContentHeader: item.branch, */
/*            balloonContentBody: '<img height="auto" width="100%" src="' +
            imagePath + '"/><div>' + item.object +
              '<br/>Стоимость объекта - ' + item.finance + ', доля федерального бюджета - ' + item.federalBudget +
              '</div>',
 */
            balloonContentBody: generateBalloonContent(imagePath, text, item.address),
/*            balloonContentFooter: item.address, */
            clusterCaption: item.address
          },
          options: {
           //  balloonPane: 'outerBalloon',
            iconColor: '#163f5f',
            balloonCloseButton: true,
            ballonAutoPan: true,
            ballonAutoPanCheckZoomRange: true,
            preset: generatePreset(item.branch),
            balloonMinHeight: balloonMinHeight,
            balloonMinWidth: balloonMinWidth,
            balloonMaxHeight: height * 0.7,
            /*
            balloonMinHeight: 450,
            balloonMinWidth: 600,
            */
            balloonPanelMaxHeightRatio: 0.7,
            balloonPanelMaxMapArea: (isMobile.phone) ? Infinity : 0
          },
          clusterName: '1'
        }
      })
    }
  },
  methods: {
    initHandler: function (map) {
      ymapsTouchScroll(map)
    }
  },
  components: {
    yandexMap, ymapMarker
  }
}
</script>
<style>
.balloon-table{
	display: table;
	width: 100%;
  height:100%;
}
.balloon-table__row {
	display: table-row;
}

.balloon-table__cell{
	display: table-cell;
}

.balloon-table__body {
	display: table-row-group;
}
.ballon-table__image_default {
  height:100%;
  background-position: center center;
  background-repeat:no-repeat;
  background-size:cover;  
}
.ballon-table__text_default {

}
.ballon-table__address_default {
  color:#aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/MyMap.vue